export default __webpack_public_path__ + "assets/instagram-legacy.015e4fc7.svg";